/** Browser connection setup: progress toasts, guide steps and session errors. */
export default {
  connect: "Connect",
  stop: "Stop",
  showSetup: "Show setup",
  connected: "Connected",
  disconnected: "Disconnected",
  connecting: "Connecting…",
  reconnecting: "Reconnecting…",
  lastVerified: "Last verified {time}",

  offerAppleEvents: "Let Denker read and use {browser} pages.",
  offerExtension:
    "Add the Denker extension so Denker can read and use {browser} pages.",
  offerTurnBackOnList:
    "Turn the Denker extension back on in {browser}'s extensions list.",
  offerTurnBackOn: "Turn the Denker extension back on in {browser}.",

  denkerBrowserName: "Denker browser",
  extOpening:
    "Opening the Denker extension's Chrome Web Store page in {browser}…",
  extOpeningDenker:
    "Opening the Denker extension's Chrome Web Store page in the Denker browser…",
  extAdd:
    "Add the Denker extension on its Chrome Web Store page in {browser}, then confirm.",
  extAddDenker:
    "Add the Denker extension on its Chrome Web Store page in the Denker browser, then confirm.",
  extAddEdge:
    "In {browser}, choose Allow extensions from other stores, then add the Denker extension and confirm.",
  extAddEdgeDenker:
    "In the Denker browser, choose Allow extensions from other stores, then add the Denker extension and confirm.",
  extOpenLink:
    "Open the link on your clipboard in {browser}, then add the Denker extension there.",
  extOpenLinkDenker:
    "Open the link on your clipboard in the Denker browser, then add the Denker extension there.",
  extTurnOn:
    "Turn the Denker extension on in {browser}: open Extensions from its menu, then Manage Extensions.",
  extTurnOnDenker:
    "Turn the Denker extension on in the Denker browser: open Extensions from its menu, then Manage Extensions.",
  extRestart:
    "The Denker extension is added but not connected yet. Close and reopen {browser} to connect it.",
  extRestartDenker:
    "The Denker extension is added but not connected yet. Close and reopen the Denker browser to connect it.",
  extConsent:
    "Choose Agree and continue on the Denker welcome page in {browser}.",
  extConsentDenker:
    "Choose Agree and continue on the Denker welcome page in the Denker browser.",
  extOutdated:
    "The Denker extension in {browser} is older than this version of Denker needs. The browser updates it on its own; restarting the browser applies a waiting update.",
  extOutdatedDenker:
    "The Denker extension in the Denker browser is older than this version of Denker needs. The browser updates it on its own; restarting the browser applies a waiting update.",
  extConnected: "Connected.",
  extStopped: "Setup stopped.",
  extPageUnavailable:
    "Denker could not open the Chrome Web Store in {browser}. Try again.",
  extPageUnavailableDenker:
    "Denker could not open the Chrome Web Store in the Denker browser. Try again.",
  extBrowserClosed: "{browser} closed during setup. Try again.",
  extBrowserClosedDenker: "The Denker browser closed during setup. Try again.",
  extTimedOut: "Setup took too long. Try again.",
  extFailed: "Setup could not continue. Try again.",

  guideSafariAdvanced: "Click Advanced.",
  guideSafariFeatures: "Show features for web developers.",
  guideSafariDeveloper: "Click Developer.",
  guideChromiumView: "Click View.",
  guideChromiumDeveloper: "Open the Developer menu.",
  guideJavascript:
    "Click Allow JavaScript from Apple Events. Your browser requires this click.",
  guideJavascriptConfirmation:
    "Click Allow in Safari’s JavaScript confirmation.",
  guideAutomation: "Allow Denker to use this browser.",
  guideAutomationExpand: "Open Denker’s browser permissions.",
  guideChecking: "Checking browser access…",
  guideUnavailable:
    "Denker could not identify a visible browser control. Check the open browser, then try again.",
  guideStopped: "Guide stopped.",
  guideLocatingChrome: "Locating the Chrome control…",
  guideOpeningSetting: "Opening the setting…",
  guideCheckingConnection: "Checking the connection…",

  approvalJavascript:
    "In {browser}, choose View → Developer → Allow JavaScript from Apple Events. Denker will continue when access is ready.",
  approvalOpenPage:
    "Open a page in {browser}. Denker will continue when access is ready.",
  approvalAutomation:
    "Allow {browser} under Denker in System Settings → Privacy & Security → Automation. Denker will continue when access is ready.",
  approvalFinish:
    "Finish {browser}’s approval in the open setup. Denker will continue when access is ready.",
  approvalWaiting: "Waiting for {browser} approval…",

  setupStoppedToast: "Connection setup stopped.",
  notConnectedYet: "Not connected yet. Finish the browser’s approval in setup.",
  anotherSetup: "Another browser setup is running.",
  disconnectingBusy: "Disconnecting. Try again when it finishes.",

  errorSetupStopped: "Setup stopped. Settings already enabled remain enabled.",
  errorSettingUnidentified:
    "Denker could not identify the setting. See Troubleshooting.",
  errorSettingNotFound:
    "The setting could not be located. See Troubleshooting.",
  errorConnectionUnfinished:
    "Connection could not finish. Try connecting again.",
  errorSessionUnavailable:
    "Browser connection is unavailable. Reopen Settings to try again.",
  errorCheckFailed: "Could not check the connection.",
  errorDisconnectFailed: "Could not disconnect the browser. Try again.",
  errorSafariVerify: "Could not verify Safari access. Try again.",
  errorReadAccess: "Could not read browser access. Try again.",

  popupRefusedTitle: "Cookie banner closed",
  popupRefusedLine:
    "{site}: kept only the necessary cookies, so the page is clear.",
  popupHiddenTitle: "Cookie banner hidden",
  popupHiddenLine:
    "{site}: it had no option to decline, so it was hidden. Nothing was accepted.",
  popupClosedTitle: "Pop-up closed",
  popupClosedLine: "{site}: closed a pop-up that covered the page.",
  popupHintTitle: "Close cookie banners and pop-ups?",
  popupHint:
    "{site} showed a cookie banner or a pop-up. Denker can refuse cookie banners and close pop-ups on the pages it opens.",
  popupTurnOn: "Turn on",
  popupTurnedOnTitle: "Closing cookie banners and pop-ups",
  popupTurnedOn:
    "On. You can turn it off in Settings › Plugins › Connections › Browsers.",
  popupTurnOnFailed:
    "Could not turn it on. Try in Settings › Plugins › Connections › Browsers.",
} as const;
